const routes = {
    HOME: '/',
    MANAGE: '/manage/:id',
    otherPage: {
        ERROR: '*',
    },
    auth: {
        LOGIN: '/login',
        SIGNUP: '/signup',
    },
};

export default routes;
